import { Message } from "../../../domain/model/Auth";
import { Answer } from "../../../domain/model/Question";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { AnswerRepository } from "./AnswerRepository";

export class AnswerRepositoryImpl implements AnswerRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  createAnswer(answer: Answer): Promise<Response<Message>> {
    return this.apiService.createAnswer(answer);
  }
  getAnswers(): Promise<Response<Array<Answer>>> {
    return this.apiService.getAnswers();
  }
  getAnswer(id: string): Promise<Response<Answer>> {
    return this.apiService.getAnswer(id);
  }
  getAnswerByQuestionId(id: string): Promise<Response<Answer>> {
    return this.apiService.getAnswerByQuestionId(id);
  }
  getAnswersByListOfQuestionsId(
    questionsId: string,
  ): Promise<Response<Array<Answer>>> {
    return this.apiService.getAnswersByListOfQuestionsId(questionsId);
  }
  updateAnswer(answer: Answer): Promise<Response<Message>> {
    return this.apiService.updateAnswer(answer);
  }
  deleteAnswer(id: string): Promise<Response<Message>> {
    return this.apiService.deleteAnswer(id);
  }
  deleteAnswerByQuestionId(id: string): Promise<Response<Message>> {
    return this.apiService.deleteAnswerByQuestionId(id);
  }
  deleteAnswerAttachment(id: string): Promise<Response<Message>> {
    return this.apiService.deleteAnswerAttachment(id);
  }
}
